
import Card from '../ss-card'

import { defineComponent } from 'vue'

export default defineComponent({
    name: "bc-expander",
    components: {
        Card
    },
    props: {
        title: { type: String, default: undefined },
        icon: { type: String, default: undefined },
        open: { type: String, default: undefined }
    },
    data() {
        return {
            // 生成一个随机数作为id
            expanderId: Math.random().toString(36).substr(2),
            isOpen: false
        }
    },
    methods: {
        changeExpander() {
            this.isOpen = !this.isOpen
            const body = document.getElementById('bcexp-' + this.expanderId)
            if(body) {
                if(this.isOpen) {
                body.style.height = (body.children[0] as HTMLDivElement).offsetHeight + 'px'
                } else {
                    body.style.height = '0'
                }
            }
        }
    },
    mounted() {
        if(this.open != undefined) {
            this.changeExpander()
        }
    }
})
